import { useId } from 'react'
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

interface Props {
  data: Record<string, unknown>[]
  xKey: string
  yKey: string
  format?: (v: number | null | undefined) => string
  color?: string
  height?: number
  label?: string
}

export function MetricLine({
  data,
  xKey,
  yKey,
  format,
  color = 'hsl(var(--primary))',
  height = 180,
  label,
}: Props) {
  const uid = useId()
  const gradId = `g-${yKey}-${uid}`
  return (
    <div style={{ width: '100%', height }}>
      <ResponsiveContainer>
        <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={color} stopOpacity={0.35} />
              <stop offset="95%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
          <XAxis
            dataKey={xKey}
            tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }}
            tickFormatter={(v) =>
              typeof v === 'string' ? new Date(v).toLocaleTimeString() : String(v)
            }
            stroke="hsl(var(--muted-foreground))"
          />
          <YAxis
            tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }}
            tickFormatter={(v) => (format ? format(v) : String(v))}
            stroke="hsl(var(--muted-foreground))"
            width={60}
          />
          <Tooltip
            contentStyle={{
              background: 'hsl(var(--card))',
              border: '1px solid hsl(var(--border))',
              borderRadius: 6,
            }}
            formatter={(v) =>
              format ? format(Number(v)) : String(v)
            }
            labelFormatter={(v) =>
              typeof v === 'string' ? new Date(v).toLocaleString() : String(v)
            }
          />
          <Area
            type="monotone"
            dataKey={yKey}
            stroke={color}
            strokeWidth={2}
            fill={`url(#${gradId})`}
            isAnimationActive={false}
            name={label || yKey}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  )
}
